import { Typography } from "@mui/material";
import Model from "../base/Model/ui";
import { Col, Row } from "../base/Flex/ui";
import BasicButton from "../Buttons/BasicButton";

export const UnsupportTokenModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Model.Wrapper open={open} onClose={onClose}>
      <Model.Container size="md">
        <Model.Header.Wrapper>
          <Model.Header.Title />
          <Model.Header.CloseButton close={onClose} />
        </Model.Header.Wrapper>
        <Model.Content>
          <Col
            type="cc"
            sx={{
              marginX: "auto",
              textAlign: "center",
              gap: "16px",
            }}
            fullWidth>
            <Row type="cc" fullWidth fullHeight>
              <Typography variant="mobile-h2">Token Not Supported</Typography>
            </Row>
            <Row type="cc" sx={{ padding: "32px" }} fullWidth fullHeight>
              <Typography variant="mobile-body-s-heavy" color="text.secondary">
                We currently do not support this token / chain yet. <br />
                We will get there soon. Stay tuned!
              </Typography>
            </Row>
            <Row type="sc" sx={{ padding: "0 32px" }} fullWidth>
              <BasicButton variant="white" sx={{ width: "100%" }} onClick={onClose}>
                <Typography variant="mobile-action-s-heavy" color="text.btn-dark">
                  Back
                </Typography>
              </BasicButton>
            </Row>
          </Col>
        </Model.Content>
      </Model.Container>
    </Model.Wrapper>
  );
};
